import { ReactNode } from 'react';
import { createRoot } from 'react-dom/client';
import { AppContextProvider } from './provider';

type Props = {
  container: HTMLElement;
  children: ReactNode;
};
export const portalWithAppContext = ({ container, children }: Props) => {
  const root = createRoot(container);

  root.render(<AppContextProvider>{children}</AppContextProvider>);

  return root;
};
